import React, { useState, useEffect, useRef } from "react";
import DateRangeSelector from "../dashboard/calendars/DateRangeSelector";
import { default as ReactSelect } from "react-select";
import { useTranslation } from "react-i18next";
import DateFormat from "../../pages/DateFormat";
import APIUrls from "../../services/APIUrls";
import { downloadFile, getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import { handleError } from "../../services/authApiRoutes/APImethods";
import { calenderIcon, InterchangeIcon, SearchIcon } from "../../AppIcons";
import { currentDate, dateDifference, getRangeDates } from "../../services/Util";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { ConditionalBlock } from "../../ConditionalBlock";
import { updateFinanceFilters } from "../../redux/reducers/FinanceProjectFilterSlice";
import DateRangeFilter from "../dashboard/DateRangeFilter";


export default function FinanceFilter(prop) {
  const { t } = useTranslation();
  const translate = t;
  const dispatch = useDispatch();
  const projectFilters = useSelector((reduxStore) => reduxStore.finance_project_filters);
  const [search, setSearch] = useState('');
  const [accountNames, setAccountNames] = useState();
  const [selectedAccountName, setSelectedAccountName] = useState();
  const selectedRange = useSelector((CalendarRangeSlice) => CalendarRangeSlice.calendar_range).range;
  const selectedDateRange = getRangeDates(selectedRange);

  useEffect(() => {
    prop.setDateFilter(selectedDateRange);
  }, [selectedRange]);

  useEffect(() => {

    getAxiosResponse(APIUrls.ACCOUNT_NAMES_FINANCE)
      .then((res) => {
        if (res.data.code === 200) {
          const options = res?.data?.data?.map(({ id, name }) => ({
            label: name,
            value: id,
          }));
          setAccountNames(options);

          if (prop.retainFilter) {
            setSelectedAccountName(projectFilters.Account_Name.value);
            prop.setAccountNameFilter(projectFilters.Account_Name.value);
          } else {
            setSelectedAccountName(options[0].value);
            prop.setAccountNameFilter(options[0].value);
            dispatch(updateFinanceFilters({ Account_Name: options[0] }));
          }
        }
      })
      .catch((err) => {
        handleError(err);
      });

  }, []);

  const handleAccountNameChange = (event) => {
    setSelectedAccountName(event.value);
    prop.setAccountNameFilter(event.value);
    dispatch(updateFinanceFilters( {Account_Name: event}));
  };

  const handleSearchChange = (value) => {
    setSearch(value);
    prop.setSearchText(value);
  };

  return (
    <div id="filterBtn" className="filter-content show-flex" projectlisting-tour="basic-filter">
      <div className="filter-inline-list">

        <div className="department-dropdown-lg flex-center global-dropdown-block mb-0">
          <ReactSelect
            classNamePrefix='cw'
            aria-label="Project status"
            className="global-dropdown-select"
            placeholder={translate("project_listing.account_name")}
            options={accountNames}
            value={accountNames?.filter(function (option) {
              return option.value === selectedAccountName;
            })}
            onChange={handleAccountNameChange}
          />
        </div>

      </div>

      <div className="filter-inline-list">
  <DateRangeFilter dateFormat={'MM/DD/YY'} showRangeDropDown={false} />
</div>

      {prop.showProjectNameFilter && <div className="filter-inline-list">
        <div className="search width-255 activity-search">
          <input
            style={{ border: "none" }}
            type="text"
            placeholder={translate("project_listing.project_name")}
            id="search"
            name="search"
            className="search-control"
            value={search}
            onChange={(e) => {
              handleSearchChange(e.target.value);
            }}
          />
          <button className="submit" aria-label="search">
            {SearchIcon}
          </button>
        </div>
      </div>}

      <div className="filter-inline-list flex">
        <button id="advance-activeId" className="active dashboard-btn mr-12" projectlisting-tour="advance-filter" onClick={() => prop.setShowAdvanceFilter(true)}>
          {translate("project_page.advance")}
        </button>
        {prop.showDownloadReport && <button id="advance-activeId" className="dashboard-btn" onClick={() => prop.downloadReport()}>Download Report</button>}
        <ConditionalBlock condition={prop.requestFromProject}>
          <button id="import-bulk" className="active dashboard-btn mr-12" onClick={() => prop.setShowBulkImport(true)}>
            {translate("finance.import_bulk")}
          </button>
        </ConditionalBlock>

      </div>

    
    </div>
  );
}
